import React, { useContext, useEffect, useState } from "react";
import * as Sentry from "@sentry/react";
import { Routes, Route } from "react-router-dom";
import AnonymousRoute from "./helpers/AnonymousRoute/AnonymousRoute";
import ProtectedRoute from "./helpers/ProtectedRoute/ProtectedRoute";
import PageNotFound from "./domain/Error/PageNotFound/PageNotFound";
import AuthenticationService from "./services/AuthenticationService/AuthenticationService";
import UserContext from "./context/UserContext/UserContext";
import AppLoading from "./AppLoading";
import { anonymousRoutes, protectedRoutes } from "./settings/routes";

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

const AppMain = () => {
  const setUser = useContext(UserContext)[1];
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function fetchMe() {
      const user = await AuthenticationService.me();
      setUser(user);
      setIsLoading(false);
    }

    fetchMe();
  }, [setUser, setIsLoading]);

  return isLoading ? (
    <AppLoading />
  ) : (
    <SentryRoutes>
      {anonymousRoutes.map(({ path, component: Component }) => (
        <Route
          key={path}
          path={path}
          element={
            <AnonymousRoute>
              <Component />
            </AnonymousRoute>
          }
        />
      ))}
      {protectedRoutes.map(({ path, component: Component, routeProps = {} }) => (
        <Route
          key={path}
          path={path}
          element={
            <ProtectedRoute {...routeProps}>
              <Component />
            </ProtectedRoute>
          }
        />
      ))}
      <Route path="*" element={<PageNotFound />} />
    </SentryRoutes>
  );
};

export default AppMain;
